import './polyfills'

void import('./bootstrap')
